export default {
  defaultProps: {
    disableTypography: true,
  },
};
